// extracted by mini-css-extract-plugin
export default {"gstReturnBox":"gstReturn_gstReturnBox__WadIO"};